/** 画面名定数（文言取得に使用） */
export const DELIVERY_CAP_SETTING_FILE_NAME = "DeliveryCapSetting";

/** 曜日配列（テーブルヘッダー表示用） */
export const WEEKS: string[] = ["日", "月", "火", "水", "木", "金", "土"];
